import type { ContentBugReportBody } from '@mathflat/domain/Inquiry'
import { makeAutoObservable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import { bugReportController } from '@/controller/bugReport.controller'
import { ErrorReport } from '@/dto'

class ErrorReportService {
  type?:
    | 'ARITHMETIC'
    | 'PROBLEM_PUBLIC'
    | 'PROBLEM_PUBLIC_ANSWER_NOT_CONFIRMED'
    | 'PROBLEM_CUSTOM'
    | 'CONCEPT'
    | 'LITTLE_CHAPTER'
  errorOption = new ErrorReport({ categoryId: EMPTY_NUMBER_ID, type: undefined })

  constructor(
    type: ErrorReportService['type'],
    categoryId: number,
    additionalInfo?: ContentBugReportBody['additionalInfo'],
  ) {
    this.type = type
    this.errorOption = new ErrorReport({
      categoryId,
      type,
      originWorkbookId: additionalInfo?.originWorkbookId ?? undefined,
      tagTop: additionalInfo?.tagTop,
    })
    makeAutoObservable(this)
  }

  clearErrorReport = () => {
    this.errorOption = new ErrorReport({ categoryId: EMPTY_NUMBER_ID, type: undefined })
    this.type = undefined
  }

  changeOption = (subtype: ErrorReport['subtype']) => {
    this.errorOption.setSubType(subtype)
  }

  postErrorReportConcept = async (
    type: Extract<ErrorReportService['type'], 'LITTLE_CHAPTER' | 'CONCEPT'>,
  ) => {
    if (type === 'CONCEPT') {
      await bugReportController.postErrorReportConcept(this.errorOption.bugReportData)
    } else {
      await bugReportController.postErrorReportLittleChapter(this.errorOption.bugReportData)
    }
  }
  postErrorReportPublicProblem = async () => {
    await bugReportController.postErrorReportPublicProblem(this.errorOption.bugReportData)
  }
  postErrorReportCustomProblem = async () => {
    await bugReportController.postErrorReportCustomProblem(this.errorOption.bugReportData)
  }
  postErrorReportArithmetic = async () => {
    await bugReportController.postErrorReportArithmetic(this.errorOption.bugReportData)
  }
}

export default ErrorReportService
